import { http } from "./httpServices";
import { ADMIN_DASHBOARD, ADMIN_LOGIN } from "./constants";

export function adminLogin(data: { email: string; password: string }) {
  return http.post(ADMIN_LOGIN, data);
}

export function getDashboardData(date:string) {
  return http.get(`${ADMIN_DASHBOARD}?searchDate=${date}`);
}
